<template>
  <div class="row m-0">
    <div class="col-12 ">
      <div class="row justify-content-center">
        <div class="col-lg-12 pl-lg-0 pr-lg-1">
          <div class="row m-0 ">
            <card title="Driver Details">
              <div class="row mx-0 mb-3">
                <div class="col-12 mb-2 bold">
                  Driver Details
                </div>
                <div class="col-12 mb-4">
                  <input type="email" v-model="email" class="form-control w-100" >
                </div>
                <div class="col-12">
                  <button type="button" class="btn btn-primary font14" @click="onSubmit">Add</button>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import loadingMixin from '@/mixins/loading'

export default {
  components: {
    Card: () => import('@/components/common/Card.vue') // ,
    // TextInput: () => import('@/components/common/TextInput.vue')
  },
  data () {
    return {
      email: '',
      drivers: []
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['addDriver']),
    async onSubmit () {
      try {
        this.showLoading()
        await this.addDriver({
          email: this.email
        })
        this.email = ''
      } catch (error) {
        alert('Error: ' + error.message)
      }
      this.hideLoading()
    }
  },
  mixins: [loadingMixin]
}
</script>

<style scoped>
.edit_icon {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  bottom: -0.3rem;
  right: 0;
  z-index: 2;
  color: var(--dark-color);
}
.dark-mode .edit_icon {
  color: var(--light-color);
}
  .btn_add {
    color: white;
    cursor: pointer;
    border: 1px solid white;
    position: absolute;
    bottom: 0;
    left: 100%;
    z-index: 99;
  }
</style>
